import styled, { css } from 'styled-components';

import { YatLogo } from '@pkg/assets/brand';

import { SkeletonLoader } from '../../SkeletonLoader';

export const DepNftAssetLoader = styled(SkeletonLoader)`
    height: 100%;
    background: #000, radial-gradient(100% 0%, rgba(255, 255, 255, 1) 100%, rgba(255, 255, 255, 1) 100%);
    border-radius: 6px 6px 0 0;
`;

export const Loading = styled.div`
    display: block;
    width: 100%;
    aspect-ratio: 1/1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
`;

///
/// Asset Error

export const ErrorWrapper = styled.div`
    && {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        aspect-ratio: 1;
        border-radius: 6px;
        background: radial-gradient(
                70.94% 70.94% at 36.73% 29.06%,
                rgba(255, 255, 255, 0.05) 0%,
                rgba(255, 255, 255, 0) 100%
            )
            rgba(255, 255, 255, 0.06);

        user-select: none;
        pointer-events: none;
    }
`;

export const ErrorSquare = styled.div<{ $background?: boolean }>`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;

        ${({ $background }) =>
            $background &&
            css`
                margin-bottom: 8px;
                border-radius: 8px;
                background: ${({ theme }) => theme.shades.black[10]};
            `}
    }
`;

export const ErrorIconWrapper = styled.div`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        opacity: 0.3;
    }
`;

export const ErrorIcon = styled(YatLogo)`
    && {
        margin: 0 auto;
        width: 100%;
        height: 100%;
        fill: white;
    }
`;

export const ErrorText = styled.span`
    && {
        font-family: 'Alliance No.1';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        letter-spacing: -0.1px;
        color: ${({ theme }) => theme.colors.white};
        opacity: 0.5;
    }
`;

///
/// Asset Handler

interface BaseAssetProps {
    $isSold?: boolean;
    $dataSrc?: string;
    $objectFit?: 'cover' | 'contain';
}

const BaseAssetStyles = css<BaseAssetProps>`
    display: block;
    width: 100%;

    aspect-ratio: 1/1;
    border-radius: 6px;
    opacity: ${({ $isSold }) => ($isSold ? 0.3 : undefined)};

    object-fit: ${({ $objectFit }) => $objectFit || 'cover'};
`;

export const StyledVideo = styled.video<BaseAssetProps>`
    && {
        ${BaseAssetStyles}
    }
`;

export const StyledImage = styled.img<BaseAssetProps>`
    && {
        ${BaseAssetStyles}
        ${({ $dataSrc }) =>
            !$dataSrc &&
            css`
                visibility: hidden;
            `}
    }
`;
